import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Mail } from "lucide-react";
import { toast } from "sonner";

export const ReceiptLimitControl = ({ row, onSaved }) => {
  const [value, setValue] = useState(String(row.receipt_limit));
  const [busy, setBusy] = useState(false);
  const dirty = Number(value) !== row.receipt_limit;

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put(`/platform/restaurants/${row.id}/receipt-limit`, { limit: Number(value) });
      onSaved(data.receipt_limit);
      toast.success(`Receipt limit for ${row.name} set to ${data.receipt_limit}/month`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const full = row.receipts_this_month >= row.receipt_limit;

  return (
    <form onSubmit={save} className="flex items-center gap-2 text-sm">
      <Mail className="h-4 w-4 text-slate-400" />
      <span data-testid={`setup-receipt-usage-${row.id}`} className={full ? "text-red-400" : "text-slate-400"}>{row.receipts_this_month} /</span>
      <input data-testid={`setup-receipt-limit-${row.id}`} type="number" min={0} max={100000} required value={value} onChange={(e) => setValue(e.target.value)} className="w-20 bg-slate-800 border border-slate-700 rounded-lg px-2 py-1.5 text-sm font-mono-j focus:outline-none focus:border-orange-500" />
      <span className="text-slate-500 text-xs">receipts/month</span>
      {dirty && (
        <button data-testid={`setup-receipt-save-${row.id}`} disabled={busy} className="rounded-lg bg-orange-600 hover:bg-orange-700 px-2.5 py-1.5 text-xs font-semibold disabled:opacity-60 transition-colors">Save</button>
      )}
    </form>
  );
};
